import { TrackDef } from '../track.js';

/**
 * ANCHORAGE YARDS — Orbital shipyard, intermediate.
 * The league's pack-racing crucible: eight ships wide between berthed hulls,
 * long drafting straights, sweeping gantry curves, and a lane divider that
 * splits the front straight in two. Pick a side early.
 */
export const anchorage: TrackDef = {
  id: 'anchorage',
  name: 'Anchorage Yards',
  tagline: 'Eight abreast down the berth rows — draft hard and commit to a lane at the divider.',
  environment: 'shipyard',
  difficulty: 2,
  layout: 'circuit',
  defaultLaps: 3,
  width: 30,
  unlockLevel: 3,
  points: [
    { x: -150, y: 30, z: 0, width: 32 },
    { x: -150, y: 30, z: 260, width: 32 },
    { x: -120, y: 33, z: 550, width: 32 },
    { x: 40, y: 36, z: 800, width: 30, roll: -0.25 },
    { x: 300, y: 42, z: 930, width: 28, roll: -0.3 },
    { x: 560, y: 38, z: 890, width: 28, roll: -0.28 },
    { x: 710, y: 34, z: 700, width: 30, roll: -0.22 },
    { x: 745, y: 28, z: 440, width: 34 },
    { x: 735, y: 22, z: 160, width: 34 },
    { x: 690, y: 23, z: -120, width: 32, roll: -0.2 },
    { x: 590, y: 25, z: -330, width: 30, roll: -0.28 },
    { x: 390, y: 27, z: -450, width: 30, roll: -0.3 },
    { x: 150, y: 29, z: -490, width: 32 },
    { x: -80, y: 31, z: -440, width: 30, roll: -0.28 },
    { x: -175, y: 30, z: -230, width: 30, roll: -0.32 },
  ],
  features: [
    { kind: 'hazard', s: 0.045, length: 0.03, lane: 0, width: 7, type: 'barrier' },
    { kind: 'boost', s: 0.08, length: 0.007, lane: -0.4 },
    { kind: 'boost', s: 0.083, length: 0.007, lane: 0.4 },
    { kind: 'zone', s: 0.21, length: 0.14, name: 'gantries' },
    { kind: 'boost', s: 0.45, length: 0.007, lane: 0 },
    { kind: 'zone', s: 0.5, length: 0.12, name: 'drydock' },
    { kind: 'boost', s: 0.55, length: 0.007, lane: -0.35 },
    { kind: 'boost', s: 0.58, length: 0.007, lane: 0.35 },
    { kind: 'boost', s: 0.83, length: 0.007, lane: 0 },
  ],
  medals: { bronze: 49.3, silver: 42.4, gold: 37.9, author: 35.2 },
};
